import React, {
  useRef,
  useContext,
  useEffect,
  forwardRef,
  ReactNode
} from 'react';
import { observer } from 'mobx-react';
import { ActionMenu, Icon } from 'components/atoms';
import { UiContext } from 'contexts';
import {
  StyledPopup,
  MegaModalTopbar,
  MegaModalTitle,
  MegaModalClose,
  MegaModalContent
} from './mega-modal-style';

interface MegaModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  actionItems?: any[];
  closeOnDocumentClick?: boolean;
}

const MegaModal = observer(
  forwardRef<HTMLDivElement, MegaModalProps>(
    (
      {
        title,
        open,
        onClose,
        children,
        actionItems,
        closeOnDocumentClick = true
      },
      ref
    ) => {
      const { setOpen, setModalType } = useContext<any>(UiContext);
      const popupRef: any = ref || useRef();

      // Ensure this closes even when using things like browser history
      useEffect(() => {
        return () => setOpen(false);
      }, []);

      return (
        <StyledPopup
          closeOnEscape
          closeOnDocumentClick={closeOnDocumentClick}
          arrow={false}
          onOpen={() => {
            setModalType('mega');
            setOpen(true);
          }}
          onClose={() => {
            setModalType(null);
            setOpen(false);
            onClose();
          }}
          contentStyle={false}
          open={open}
          ref={popupRef}
        >
          <MegaModalTopbar>
            <MegaModalTitle>{title}</MegaModalTitle>
            {Array.isArray(actionItems) && actionItems.length > 0 && (
              <ActionMenu items={actionItems} portalBreakpoint maxVisible={3} />
            )}
            <MegaModalClose onClick={() => popupRef.current.close()}>
              <Icon name='cross1' size='var(--font-size-xl)' />
            </MegaModalClose>
          </MegaModalTopbar>
          <MegaModalContent>
            <>{children}</>
          </MegaModalContent>
        </StyledPopup>
      );
    }
  )
);

export default MegaModal;
